import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '../../assets/panda_logo.svg'
import _imports_1 from '../../assets/error_panda.svg'


const _hoisted_1 = { class: "error-header-primary" }
const _hoisted_2 = { class: "header-area" }
const _hoisted_3 = {
  key: 0,
  class: "error-logo"
}
const _hoisted_4 = {
  key: 1,
  class: "error-logo"
}
const _hoisted_5 = { class: "error" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = {
  class: "flex justify-between",
  style: {"flex-direction":"column"}
}

import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import http from '../../common/axios-common';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import loginUserStore from '../../store/loginUserStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'ERROR',
  setup(__props) {

const poType = ref('');

// ログイン情報取得
const getLoginUser = () => {
  const loginUser = loginUserStore();
  const { po_type } = storeToRefs(loginUser);
  http
    .post('/ctp001001/loginUser')
    .then((response) => {
      // 異常終了の場合
      if (response.data.common.status === ResultStatusCode.ERROR) {
        poType.value = 'UNKNOWN';
      } else {
        // ログインユーザー情報をstoreに設定
        loginUser.setLoginUser(response.data.loginUser);
        poType.value = po_type.value;
      }
    })
    .catch(() => {
      poType.value = 'UNKNOWN';
    });
};

getLoginUser();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (poType.value === 'PO_NORMAL')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_router_link, { to: { name: 'login' } }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: ""
                  }, null, -1)
                ])),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[1] || (_cache[1] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              }, null, -1)
            ])))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[2] || (_cache[2] = _createElementVNode("div", null, [
            _createElementVNode("h2", { class: "q-mb-md" }, "ERROR"),
            _createElementVNode("p", null, [
              _createTextVNode(" 内部エラーが発生しました。"),
              _createElementVNode("br"),
              _createTextVNode(" 問題が解決しない場合は、ヘルプデスクにお問い合わせください。 ")
            ])
          ], -1)),
          (poType.value === 'PO_NORMAL')
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 0,
                label: "ログイン画面へ戻る",
                outline: "",
                color: "primary",
                to: { name: 'login' }
              }))
            : _createCommentVNode("", true)
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col image text-center" }, [
          _createElementVNode("img", {
            src: _imports_1,
            alt: ""
          })
        ], -1))
      ])
    ])
  ], 64))
}
}

})